module.exports = __webpack_public_path__ + "static/media/arrow-right.b8ae1ddd.svg";